export default "__VITE_ASSET__BpscIrOj__"